import { msg } from "@lingui/core/macro";
import { getNameParts } from "./name";

export function getGreeting(name: string) {
  const { firstName } = getNameParts(name);

  const hour = new Date().getHours();

  if (hour < 12) {
    return firstName ? msg`Good morning, ${firstName}` : msg`Good morning`;
  }

  if (hour < 18) {
    return firstName ? msg`Good afternoon, ${firstName}` : msg`Good afternoon`;
  }

  return firstName ? msg`Good evening, ${firstName}` : msg`Good evening`;
}
